import TableModule from "components/Modules/Collections/TableModule"
import { getDataFromFirestoreCollection } from "helpers/Firestore"
import React from "react"

const CityNotificationsTable = () => {
  return (
    <TableModule
      getData={async ({ firebaseUID }) => {
        const data = await getDataFromFirestoreCollection({
          path: `City/Cities/DataBase/${firebaseUID}/Modules/notifications/DataBase`,
        })

        console.log("data", data)

        return data
      }}
      columns={[{ key: "Title", label: "Title" }]}
      searchKey={"Title"}
    />
  )
}

export default CityNotificationsTable
